import { Button, Popover, Space, Table, message } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import DeleteButton from "../UI/DeleteButton/deletebutton";
import PrintButton from "../UI/PrintButton/printbutton";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import {
  deletePayment,
  getPayment,
  getSuppliersPayments,
} from "../../api/payments";
import { AxiosResponse } from "axios";
import { EditOutlined } from "@ant-design/icons";
import { format } from "date-fns";
interface Props {
  payments: any;
  isPaymentsLoading: boolean;
  getSupplierPaymentsMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    void,
    unknown
  >;
  setPaymentById: Dispatch<SetStateAction<any>>;
  selectedsupplier: null;
}
export const PaymentList = ({
  payments,
  isPaymentsLoading,
  getSupplierPaymentsMutation,
  setPaymentById,
  selectedsupplier,
}: Props) => {
  const [t] = useTranslation("common");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<number | undefined>(undefined);
  const [nameToDelete, setNameToDelete] = useState<any>();
  const { state } = useLocation();
  const { mutateAsync: getPaymentByIdMutation } = useMutation(
    "gePaymentById",
    () => getPayment(state.id),
    {
      onSuccess: (res) => {
        setPaymentById([res?.data]);
      },
    }
  );
  useEffect(() => {
    state && getPaymentByIdMutation();
  }, []);

  const { mutateAsync: deletePaymentMuation } = useMutation(
    "deletePayment",
    () => deletePayment(idToDelete),
    {
      onSuccess: () => {
        message.success("Deleted successfully!");
      },
    }
  );

  const handleDelete = (id: number | undefined, name: string): void => {
    setOpen(true);
    setIdToDelete(id);
    setNameToDelete(name);
  };
  const handleOk = () => {
    setOpen(false);
    deletePaymentMuation().then(() => getSupplierPaymentsMutation());
  };
  const [isEditing, setIsEditing] = useState(false);
  const content = <div>{t("edit")}</div>;

  const [filteredPayments, setFilteredPayments] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsFiltering(true); // Set loading state for filtering
        if (selectedsupplier) {
          const response = await getSuppliersPayments(selectedsupplier);
          setFilteredPayments(response.data.data);
        } else {
          setFilteredPayments(payments);
        }
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setIsFiltering(false); // Clear loading state for filtering
      }
    };

    fetchData();
  }, [payments, selectedsupplier]);
  const columns: {}[] = [
    {
      title: `${t("supplier")}`,
      dataIndex: "pBill",
      key: "name",
      className: "table-header",
      render: (record: any) => {
        return <>{record.supp.name}</>;
      },
    },
    {
      title: `${t("payment-method")}`,
      dataIndex: "paymentMode",
      key: "paymentMethod",
      render: (record: any) => {
        return <>{record.mode}</>;
      },
    },
    {
      title: `${t("bill-number")}`,
      dataIndex: "pBill",
      key: "number",
      render: (record: any) => {
        return <>{record.invoiceNo}</>;
      },
    },
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("amount")}`,
      dataIndex: "amountText",
      key: "amountText",
    },
    {
      title: `${t("exchange-rate")}`,
      dataIndex: "exchangeRateText",
      key: "exchangeRateText",
    },
    {
      title: `${t("action")}`,
      fixed: "right",
      key: "action",
      width: "7rem",
      align: "center",
      render: (record: any) => (
        <Space>
          {/* <PrintButton onClick={() => console.log("hh")} /> */}
          <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
            <Button
              className="Button"
              type="text"
              icon={
                <EditOutlined style={{ color: "#212121", fontSize: "14px" }} />
              }
              onClick={() => {
                if (!isEditing) {
                  setIsEditing(true);
                  navigate(`/supplierpayment/${record?.id}`, {
                    state: { ...record },
                  });
                }
              }}
              size={"small"}
              disabled={isEditing || record.pBill.isPaid}
            />
          </Popover>

          <DeleteButton
            onClick={() => handleDelete(record?.id, record?.supplier)}
          />
        </Space>
      ),
    },
  ];
  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={nameToDelete}
        onOk={handleOk}
      />
      <Table
        loading={isFiltering || isPaymentsLoading}
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={selectedsupplier ? filteredPayments : payments}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.id}
      />
    </>
  );
};
